class PopulateProvincias {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    async loadProvincias(selectElement) {
        try {
            const response = await this.apiClient.getProvincias();
            if (response.success) {
                this.populateSelect(selectElement, response.data, 'nombre');
            }
        } catch (error) {
            console.error('Error loading provincias:', error);
        }
    }

    populateSelect(selectElement, data, valueField, textField = null) {
        if (!selectElement) return;
        
        selectElement.innerHTML = '<option value="">Seleccione una opción</option>';
        
        data.forEach(item => {
            const option = document.createElement('option');
            option.value = item[valueField];
            option.textContent = textField ? item[textField] : item[valueField];
            selectElement.appendChild(option);
        });
    }
}

window.PopulateProvincias = PopulateProvincias;